import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import Sidebar from './Sidebar';
import ProfileMenu from './ProfileMenu';
import MobileHamburger from './MobileHamburger';
import MobileMenu from './MobileMenu';
import './Main.css';
import './AuthForm.css';
import { FaArrowLeft } from 'react-icons/fa6';
import Preloader from './Preloader'; 

function AnnouncementDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [sidebarNarrow, setSidebarNarrow] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  useEffect(() => {
    const getCurrentUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('*')
          .eq('user_id', user.id)
          .single();
        setCurrentUser(profile);
      }
    };
    getCurrentUser();
    fetchAnnouncement();
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
      document.title = "Announcement Details";
    }, []);

  async function fetchAnnouncement() {
    setLoading(true);
    setError('');
    const { data, error } = await supabase
      .from('announcements')
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      setError('Failed to load announcement details.');
      setAnnouncement(null);
      console.error('Error fetching announcement details:', error);
    } else {
      setAnnouncement(data);
    }
    setLoading(false);
  }

  if (loading || !currentUser) return <Preloader text="Loading Details..." />;
  if (error || !announcement) return <div style={{ color: '#d32f2f', padding: 40 }}>{error || 'Announcement not found.'}</div>;

  const canEdit = currentUser && (
    currentUser.role === 'admin' ||
    currentUser.role === 'super admin' ||
    currentUser.role === 'barangay'
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f4f8f8' }}>
      <Sidebar onNarrowChange={setSidebarNarrow}/>
      <div style={{ flex: 1, padding: 32 }}>
        <div className="header">
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            {/* Mobile Hamburger Menu */}
            <MobileHamburger
              isOpen={showMobileMenu}
              onToggle={() => setShowMobileMenu(prev => !prev)}
            />
          <button
            onClick={() => navigate(-1)}
            style={{
              background: 'none',
              border: 'none',
              color: '#666',
              cursor: 'pointer',
              fontSize: 16,
              display: 'flex',
              alignItems: 'center',
              gap: 8
            }}
          >
            <FaArrowLeft/>
          </button>
          <div className="title-text">Announcement Details</div>
          </div>
          <ProfileMenu />
        </div>

        {/* Mobile Dropdown Menu */}
        <MobileMenu 
          isOpen={showMobileMenu} 
          onClose={() => setShowMobileMenu(false)} 
        />

        <div style={{ background: '#fff', borderRadius: 12, padding: 32, boxShadow: '0 2px 8px #0001' }}>
          <div style={{ display: 'flex', gap: 24, marginBottom: 32 }}>
            <div style={{ flex: 1 }}>
              {announcement.banner_img && (
                <img
                  src={announcement.banner_img}
                  alt="Announcement Banner"
                  style={{ width: '100%', height: 420, objectFit: 'cover', borderRadius: 8, background: '#eee' }}
                />
              )}
            </div>
            <div style={{ flex: '1 1 400px', minWidth: '300px' }}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', color: '#666', marginBottom: 4 }}>Title</label>
                <span>{announcement.title}</span>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', color: '#666', marginBottom: 4 }}>Created At</label>
                <span>{announcement.created_at ? new Date(announcement.created_at).toLocaleString() : '-'}</span>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', color: '#666', marginBottom: 4 }}>Target Scope</label>
                <span>{announcement.target_scope ? announcement.target_scope.charAt(0).toUpperCase() + announcement.target_scope.slice(1) : 'N/A'}</span>
              </div>
              {announcement.target_scope === 'barangay' && (
                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', color: '#666', marginBottom: 4 }}>Target Barangay</label>
                  <span>{announcement.target_barangay || 'N/A'}</span>
                </div>
              )}
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', color: '#666', marginBottom: 4 }}>Status</label>
                {canEdit ? (
                  <select
                    value={announcement.status}
                    onChange={async (e) => {
                      const newStatus = e.target.value.toLowerCase();
                      const { error } = await supabase
                        .from('announcements')
                        .update({ status: newStatus })
                        .eq('id', announcement.id);
                      if (!error) {
                        setAnnouncement({ ...announcement, status: newStatus });
                        // Audit log for edit/archive
                        const targetType = announcement.target_scope === 'barangay' ? 'AnnouncementBarangay' : 'AnnouncementCitywide';
                        const actionType = newStatus === 'archived' ? 'archived announcement' : 'edited announcement';
                        await supabase.from('audit_logs').insert([{
                          user_id: currentUser.id,
                          action: actionType,
                          target_id: announcement.id,
                          target_type: targetType,
                          details: {
                            title: announcement.title,
                            target_scope: announcement.target_scope,
                            target_barangay: announcement.target_barangay || null
                          }
                        }]);
                      } else {
                        alert('Failed to update status');
                      }
                    }}
                    style={{ padding: 8, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }}
                  >
                    <option value="active">Active</option>
                    <option value="draft">Draft</option>
                    <option value="archived">Archived</option>
                  </select>
                ) : (
                  <span>{announcement.status ? announcement.status.charAt(0).toUpperCase() + announcement.status.slice(1) : 'N/A'}</span>
                )}
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', color: '#666' }}/>
                <span style={{ color: '#444', fontSize: 16 }}>{announcement.content}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AnnouncementDetail;